import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { StartSales12 } from '@cian/ui-kit/icons';

import * as styles from './SalesStartLabel.css';

export const SalesStartLabel = () => {
  return (
    <div>
      <InlineText2>Старт продаж</InlineText2>
      <span className={styles['icon']}>
        <StartSales12 color="error_100" />
      </span>
    </div>
  );
};
